import { render, staticRenderFns } from "./CompanySettingSideMenu.vue?vue&type=template&id=20e056d4&scoped=true"
import script from "./CompanySettingSideMenu.vue?vue&type=script&lang=js"
export * from "./CompanySettingSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CompanySettingSideMenu.vue?vue&type=style&index=0&id=20e056d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e056d4",
  null
  
)

export default component.exports